var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11456",
    "data-name": "Group 11456",
    transform: "translate(-318 -468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11455",
    "data-name": "Group 11455",
    transform: "translate(-6 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    transform: "translate(324 466)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 17,
    rx: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    transform: "translate(321 476)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    transform: "translate(326 476)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    transform: "translate(331 476)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    transform: "translate(321 480)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    transform: "translate(326 480)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    x2: 18.033,
    transform: "translate(318.467 472.203)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    x2: 18.033,
    transform: "translate(318.467 474.071)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCalendarIcon);
export default __webpack_public_path__ + "static/media/GrayCalendarIcon.61ef874a5fcf86e30771e5e6edf0f1cd.svg";
export { ForwardRef as ReactComponent };